/* eslint-disable no-console */
import apiClient from "./api-client";
import { authHeader } from "./auth-header";
import { userService } from "../_services/user.service.js";
import { merge } from "lodash";

const actionScope = `loadingIndicator`;

export function setupInterceptors(baseURL, { dispatch }) {
  let requestsPending = 0;

  apiClient.defaults.baseURL = baseURL;

  const req = {
    pending: () => {
      requestsPending++;
      dispatch(`${actionScope}/show`);
    },
    done: () => {
      requestsPending--;

      if (requestsPending <= 0) {
        dispatch(`${actionScope}/hide`);
      }
    }
  };

  apiClient.interceptors.request.use(
    config => {
      req.pending();
      merge(config.headers.common, authHeader());

      return config;
    },
    error => {
      requestsPending--;

      req.done();

      return Promise.reject(error);
    }
  );

  apiClient.interceptors.response.use(
    ({ data, status }) => {
      req.done();

      if (status === 401) {
        return userService.logout();
      }

      return Promise.resolve(data);
    },
    error => {
      req.done();

      return Promise.reject(error);
    }
  );
}
